export const CORPORATE_WELLNESS_FORM_ID =
  '1cd2595e-46c4-49e5-85fc-df6b6471c1e7';
export const GIFTING_AND_EVENTS_FORM_ID =
  '14aa4a64-d84e-4104-8a5d-028bbec7edfb';
export const HEALTHCARE_FORM_ID = 'a4272c20-90ac-47dc-bb4a-cc751517631c';
export const MILITARY_FORM_ID = '7f0685b7-a497-4f79-b58f-2829d89b5c76';
export const RESEARCH_FORM_ID = '6527e47f-705c-4d1e-8e7d-496136693309';
export const SPORTS_FORM_ID = '8efeecda-217b-45dd-ae13-de2fcc41708c';
export const AMBASSADOR_PROGRAM_FORM_ID = 'ambassador-program';
export const API_INTEGRATION_FORM_ID = 'api-integration';
